import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectLimit = (store: StoreSchema) => store.licenseEvents.limit